import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './contexts/ThemeContext';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Consultas from './pages/Consultas/Consultas';
import Admin from './pages/Admin/Admin';
import Tenants from './pages/Admin/Tenants/Tenants';
import TenantDetail from './pages/Admin/Tenants/TenantDetail';
import TenantSubtenants from './pages/Admin/Tenants/TenantSubtenants';
import AddTenant from './pages/Admin/Tenants/AddTenant';
import Users from './pages/Admin/Users/Users';
import Profile from './pages/Profile/Profile';
import Historico from './pages/Historico/Historico';
import { authService } from './services/auth';
import AddSubTenant from './pages/AddSubTenant/AddSubTenant';
import ProtectedRoute from './components/ProtectedRoute';
import Reports from './pages/Admin/Reports/Reports';
import PriceConfigPage from './pages/PriceConfig/PriceConfigPage';

function App() {
  // Usar estado local para forçar a atualização quando o usuário fizer login
  const [isAuthenticated, setIsAuthenticated] = useState(authService.isAuthenticated());
  const [user, setUser] = useState(authService.getUser());
  const [isLoading, setIsLoading] = useState(true);
  const isAdmin = user?.role === 'admin';

  // Atualizar o estado quando o componente montar
  useEffect(() => {
    const checkAuth = () => {
      // Verificar token no localStorage
      const token = localStorage.getItem('token');
      const savedUser = localStorage.getItem('user');
      
      if (token && savedUser) {
        try {
          const parsedUser = JSON.parse(savedUser);
          
          // Se o token e o usuário são válidos, apenas atualizar o estado
          if (token.length > 10 && parsedUser && parsedUser.id) {
            // ATENÇÃO: NUNCA tente atribuir valores diretamente a authService.token ou authService.user
            // pois são propriedades somente leitura (getters)
            
            setIsAuthenticated(true);
            setUser(parsedUser);
            
            // Não precisamos atualizar o header Authorization aqui
            // Os interceptors em api.ts já cuidam disso automaticamente lendo do localStorage
          } else {
            console.warn('Token ou usuário inválidos encontrados');
            setIsAuthenticated(false);
            setUser(null);
          }
        } catch (e) {
          console.error('Erro ao restaurar sessão do usuário:', e);
          // Não remover do localStorage aqui, apenas atualizar o estado
          setIsAuthenticated(false);
          setUser(null);
        }
      } else {
        if (!token && !savedUser) {
          console.log('Não foi encontrado token nem usuário no localStorage');
        } else if (!token) {
          console.log('Não foi encontrado token no localStorage');
        } else {
          console.log('Não foi encontrado usuário no localStorage');
        }
        setIsAuthenticated(false);
        setUser(null);
      }
      
      setIsLoading(false);
    };
    
    // Verificar autenticação ao montar
    checkAuth();
    
    // Adicionar listener para mudanças no localStorage
    window.addEventListener('storage', checkAuth);
    
    // Limpar listener quando o componente desmontar
    return () => {
      window.removeEventListener('storage', checkAuth);
    };
  }, []);

  if (isLoading) {
    return <div className="loading-app">Carregando...</div>;
  }

  return (
    <ThemeProvider>
    <Router>
      <Routes>
        <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login setIsAuthenticated={setIsAuthenticated} setUser={setUser} />} />
        <Route
          path="/dashboard"
          element={
            isAuthenticated ? (
              <Dashboard />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        >
          <Route index element={<Profile />} />
          <Route path="consultas" element={<Consultas />} />
          <Route path="historico" element={<Historico />} />
          <Route path="profile" element={<Profile />} />
          <Route path="add-subtenant" element={<AddSubTenant />} />
          <Route path="admin/users" element={<Users />} />
          <Route path="admin/tenants" element={<Tenants />} />
          <Route path="tenants/:id" element={<TenantDetail />} />
          <Route path="tenants/:tenantId/price-config" element={<PriceConfigPage />} />
        </Route>
        <Route
          path="/admin"
          element={
            isAuthenticated && isAdmin ? (
              <Admin />
            ) : isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        >
          <Route index element={<Navigate to="/admin/tenants" replace />} />
          <Route path="users" element={<Users />} />
          <Route path="tenants" element={<Tenants />} />
          <Route path="tenants/:id" element={<TenantDetail />} />
          <Route path="tenants/:id/subtenants" element={<TenantSubtenants />} />
          <Route path="tenants/new" element={<AddTenant />} />
          <Route path="tenants/:tenantId/price-config" element={<PriceConfigPage />} />
          <Route path="reports" element={<Reports />} />
          <Route path="consultas" element={<Consultas />} />
          <Route path="historico" element={<Historico />} />
          <Route path="profile" element={<Profile />} />
        </Route>
        
        <Route
          path="/consultas"
          element={
            isAuthenticated ? (
              <Consultas />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/"
          element={
            isAuthenticated ? (
              isAdmin ? (
                <Navigate to="/admin" replace />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Router>
    </ThemeProvider>
  );
}

export default App;